export type BadgeType = "heating_up" | "users_checking";

export interface ShowBadge {
  show_id: string;
  badge_type: BadgeType;
  num_users: number | null;
}

import { genAbsoluteURL } from "@/components/common/utils";

// In-memory cache so multiple rows share the same in-flight request.
// Key = sorted comma-separated show IDs, Value = Promise resolving to badges.
const _badgeCache: Map<string, Promise<ShowBadge[]>> = new Map();

export async function getShowBadges(showIds: string[]): Promise<ShowBadge[]> {
  if (!showIds.length) return [];

  // Stable key so [2,1] and [1,2] map to the same entry
  const cacheKey = [...showIds].sort().join(",");

  if (_badgeCache.has(cacheKey)) {
    return _badgeCache.get(cacheKey)!;
  }

  const fetchPromise = (async () => {
    try {
      const url =
        typeof window !== "undefined"
          ? `/api/show-badges?ids=${showIds.join(",")}`
          : genAbsoluteURL(`/api/show-badges?ids=${showIds.join(",")}`);

      const res = await fetch(url);

      if (!res.ok) {
        throw new Error(`badge api error: ${res.status}`);
      }

      const data = (await res.json()) as ShowBadge[];

      return data.map((b: any) => ({
        ...b,
        badge_type: b.badge_type as BadgeType,
      }));
    } catch (error) {
      console.error(error);
      return [];
    }
  })();

  _badgeCache.set(cacheKey, fetchPromise);
  return fetchPromise;
}
